import { render, staticRenderFns } from "./UplineTab.vue?vue&type=template&id=54ee5705&"
import script from "./UplineTab.vue?vue&type=script&lang=js&"
export * from "./UplineTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports